import React, { Component } from 'react';
import propTypes from 'prop-types';
;
import { Button, CardContent, MuiTitle } from 'src/ui/mui-ui-kit';;;
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getUser, fetchLoggedInUser } from 'src/user';
import { getNDADocusignURL, getBgDocusignURL } from 'src/docusign';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { delay } from 'src/ui';
import docusignLogo from 'src/ui/assets/docusign.svg';

const NDA_TEXT =
  'We ask discretion from our customers not to share private and secure information surrounding our banking services. To achieve this we require all customers to sign a mutual NDA before getting started.';

const BOTH_TEXT =
  'Due to the high-risk nature of your business, we may need to run a background check verifying your identity. We also ask for discretion from our customer not to share private and secure information surrounding our banking services. We ask that you sign a mutual NDA and background consent before proceeding.';

// Wrapper component to provide params to class component
const StepNdaWrapper = (props) => {
  const params = useParams();
  return <StepNdaClass {...props} params={params} />;
};

class StepNdaClass extends Component {
  state = {
    ndaDocusignData: null,
    bgDocusignData: null,
    loading: true,
    ndaSigned: false,
    bgCheckSigned: false,
    checkingNda: false,
    checkingBgCheck: false,
  };

  ndaCheckStart = new Date();

  bgCheckStart = new Date();

  async componentDidMount() {
    const { setNextEnabled, params } = this.props;

    const matchedStep = params.step;

    setNextEnabled(false);

    const { user } = this.props;

    let checkingNda = false;
    let checkingBgCheck = false;

    if (!user.isBgConsentSigned && matchedStep === 'bg-signed') {
      this.checkBg();
      checkingBgCheck = true;
    }

    if (!user.hasFinishedOnboarding && user.isMerchantAdmin) {
      if (!user.isNDASigned && matchedStep === 'nda-signed') {
        this.checkNda();
        checkingNda = true;
      }
    }
    const promises = [Promise.resolve({}), Promise.resolve({})];
    if (!user.hasFinishedOnboarding && user.isMerchantAdmin) {
      if (!user.isNDASigned) {
        promises[0] = getNDADocusignURL(user.financialInstitutionId);
      }
    }

    if (!user.isBgSigned) {
      promises[1] = getBgDocusignURL(user.financialInstitutionId);
    }
    const [ndaDocusignData, bgDocusignData] = await Promise.all(promises);

    this.setState({
      ndaDocusignData: ndaDocusignData.data,
      bgDocusignData: bgDocusignData.data,
      loading: false,
      checkingNda,
      checkingBgCheck,
      ndaSigned: user.isNDASigned,
      bgCheckSigned: user.isBgConsentSigned,
    });

    const isBgConsentSigned =
      !user.financialInstitutionBgCheckNeeded || user.isBgConsentSigned;
    if (user.isMerchantAdmin) {
      if (user.isNDASigned && isBgConsentSigned) {
        setNextEnabled(true);
      }
    }
    if (!user.isMerchantAdmin) {
      if (isBgConsentSigned) {
        setNextEnabled(true);
      }
    }
  }

  async checkNda() {
    const { fetchLoggedInUser } = this.props;

    this.setState({ checkingNda: true });

    await fetchLoggedInUser();

    const { user } = this.props;

    if (!user.isNDASigned && new Date() - this.ndaCheckStart < 60000) {
      await delay(3000);
      return this.checkNda();
    }

    if (user.isNDASigned) {
      this.setState({
        ndaSigned: user.isNDASigned,
        checkingNda: false,
      });
    }

    const { setNextEnabled } = this.props;

    if (user.isNDASigned && user.isBgConsentSigned) {
      setNextEnabled(true);
    }

    return true;
  }

  async checkBg() {
    const { fetchLoggedInUser } = this.props;

    this.setState({ checkingBgCheck: true });

    await fetchLoggedInUser();

    const { user } = this.props;

    if (!user.isBgConsentSigned && new Date() - this.bgCheckStart < 60000) {
      await delay(3000);
      return this.checkBg();
    }

    if (user.isBgConsentSigned) {
      this.setState({
        bgCheckSigned: user.isBgConsentSigned,
        checkingBgCheck: false,
      });
    }

    const { setNextEnabled } = this.props;
    if (user.isMerchantAdmin) {
      if (user.isNDASigned && user.isBgConsentSigned) {
        setNextEnabled(true);
      }
    }
    if (!user.isMerchantAdmin) {
      if (user.isBgConsentSigned) {
        setNextEnabled(true);
      }
    }

    return true;
  }

  render() {
    const {
      user: { financialInstitutionBgCheckNeeded },
      user: { isMerchantAdmin },
    } = this.props;
    const {
      ndaDocusignData,
      bgDocusignData,
      loading,
      ndaSigned,
      bgCheckSigned,
      checkingNda,
      checkingBgCheck,
    } = this.state;
    if (isMerchantAdmin) {
      return (
        <CardContent className="step-nda">
          <MuiTitle size="3" hasTextColor="primary" hasTextAlign="centered">
            {`Non-Disclosure${
              financialInstitutionBgCheckNeeded ? ' & Background Checks' : ''
            } Agreement`}
          </MuiTitle>
          <p className="leading has-text-grey-medium-dark">
            {financialInstitutionBgCheckNeeded ? BOTH_TEXT : NDA_TEXT}
          </p>
          <div className="buttons is-centered">
            <Button
              isColor={ndaSigned ? 'success' : 'gradient-bright'}
              disabled={!ndaDocusignData || ndaSigned}
              isLoading={loading || checkingNda}
              href={ndaDocusignData && ndaDocusignData.url}
            >
              {ndaSigned && (
                <span className="icon is-left">
                  <FontAwesomeIcon icon={['fal', 'check-circle']} />
                </span>
              )}
              {ndaSigned ? <span>NDA Completed</span> : <span>Sign NDA</span>}
            </Button>
            {financialInstitutionBgCheckNeeded && (
              <Button
                isColor={bgCheckSigned ? 'success' : 'gradient-bright'}
                disabled={!bgDocusignData || bgCheckSigned}
                isLoading={loading || checkingBgCheck}
                href={bgDocusignData && bgDocusignData.url}
              >
                {bgCheckSigned && (
                  <span className="icon is-left">
                    <FontAwesomeIcon icon={['fal', 'check-circle']} />
                  </span>
                )}
                {bgCheckSigned ? (
                  <span>BG Consent Signed</span>
                ) : (
                  <span>Sign Background Consent</span>
                )}
              </Button>
            )}
          </div>
          {checkingNda ||
            (checkingBgCheck && (
              <p className="help has-text-centered has-text-grey-medium-dark">
                Please be patient, DocuSign may take a few moments to complete
              </p>
            ))}
          <div className="powered-by has-text-grey-medium-dark">
            Powered by
            <img src={docusignLogo} alt="DocuSign" />
          </div>
        </CardContent>
      );
    }

    // if (!isMerchantAdmin) {
    return (
      <CardContent className="step-nda">
        <MuiTitle size="3" hasTextColor="primary" hasTextAlign="centered">
          Background Check Agreement
        </MuiTitle>
        <p className="leading has-text-grey-medium-dark">
          Before performing a background check, we are required to obtain your
          consent. Please click the button below and follow the on-screen
          instructions to sign the background check consent document.
        </p>
        <div className="buttons is-centered">
          {financialInstitutionBgCheckNeeded && (
            <Button
              isColor={bgCheckSigned ? 'success' : 'gradient-bright'}
              disabled={!bgDocusignData || bgCheckSigned}
              isLoading={loading || checkingBgCheck}
              href={bgDocusignData && bgDocusignData.url}
            >
              {bgCheckSigned && (
                <span className="icon is-left">
                  <FontAwesomeIcon icon={['fal', 'check-circle']} />
                </span>
              )}
              {bgCheckSigned ? (
                <span>BG Consent Signed</span>
              ) : (
                <span>Sign Background Consent</span>
              )}
            </Button>
          )}
        </div>
        {checkingBgCheck && (
          <p className="help has-text-centered has-text-grey-medium-dark">
            Please be patient, DocuSign may take a few moments to complete
          </p>
        )}
        <div className="powered-by has-text-grey-medium-dark">
          Powered by
          <img src={docusignLogo} alt="DocuSign" />
        </div>
      </CardContent>
    );
    // }
  }
}

StepNdaClass.defaultProps = {
  params: { step: null },
};

StepNdaClass.propTypes = {
  setNextEnabled: propTypes.func.isRequired,
  user: propTypes.object.isRequired,
  fetchLoggedInUser: propTypes.func.isRequired,
  params: propTypes.object,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

const connectedStepNda = connect(mapStateToProps, {
  fetchLoggedInUser,
})(StepNdaWrapper);

export { connectedStepNda as StepNda };
